// A API retorna data_jogo como string literal "YYYY-MM-DD HH:mm:ss" (sem timezone,
// ver backend/src/config/database.js: dateStrings). Nunca reinterpretar esse valor
// com conversão de fuso — apenas trocar o espaço por 'T' para o Date aceitar o
// formato de forma consistente entre navegadores (Safari não parseia o formato com
// espaço), sem adicionar 'Z'/offset (o que forçaria uma conversão de fuso).

// Helper genérico: qualquer coluna DATE/DATETIME/TIMESTAMP vinda da API agora é uma
// string "YYYY-MM-DD HH:mm:ss" (dateStrings: true). new Date() com espaço em vez de
// 'T' funciona no Chrome/Firefox/Node, mas falha ("Invalid Date") no Safari/iOS —
// por isso todo `new Date(campoDeData)` no frontend deve passar por aqui.
export function parseDataSQL(str) {
  if (!str) return null;
  return new Date(str.replace(' ', 'T'));
}

export function parseDataJogo(str) {
  return parseDataSQL(str);
}

// Preenche um <input type="datetime-local"> a partir do valor bruto vindo da API,
// sem passar por Date (evita qualquer conversão de fuso na exibição do formulário).
export function toDatetimeLocalValue(str) {
  if (!str) return '';
  return str.replace(' ', 'T').slice(0, 16);
}
